export default [
    
    {
      path: '/',
      name: 'main',
      component: () => import('@/views/main/index'),
      meta: {
        title: '恋TA会员充值_唯一官方充值渠道，恋TAAPP官网',
      }
    },
    {
      path: '/aliPay',
      name: 'aliPay',
      component: () => import('@/views/main/aliPay'),
      meta: {
        title: '恋TA会员充值_唯一官方充值渠道，恋TAAPP官网',
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/main/register'),
      meta: {
        title: '恋TA会员充值_唯一官方充值渠道，恋TAAPP官网',
      }
    },
    {
      path: '/weChat',
      name: 'weChat',
      component: () => import('@/views/main/weChat'),
      meta: {
        title: '恋TA会员充值_唯一官方充值渠道，恋TAAPP官网',
      }
    },
  ]
  